import * as keyapis_ad_v1_marketplace_pb from "./v1/keyapis_ad_marketplace_v1.pb";
import * as keyapis_ad_v1_salepoint_pb from "./v1/keyapis_ad_salepoint_v1.pb";
import * as keyapis_ad_v1_system_pb from "./v1/keyapis_ad_system_v1.pb";

export default {
  v1: {
    resources: {
      marketplace: keyapis_ad_v1_marketplace_pb,
      salepoint: keyapis_ad_v1_salepoint_pb,
      system: keyapis_ad_v1_system_pb,
    },
  },
};
